import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IUsersState, USERS_KEY } from '../models/users.model';
import { UnreadCountersStates } from 'src/app/shared/enums';

const selectFeature = createFeatureSelector<IUsersState>(USERS_KEY);

export const selectUsersState = createSelector(selectFeature, (state: IUsersState) => state);

export const selectCurrentUser = createSelector(
  selectFeature,
  (state: IUsersState) => state.currentUser,
);

export const selectCounters = createSelector(selectFeature, (state: IUsersState) => state.counters);

export const selectUnreadCommentsCounter = createSelector(
  selectFeature,
  (state: IUsersState) => state.counters?.[UnreadCountersStates.comments],
);

export const selectUnreadRepliesCounter = createSelector(
  selectFeature,
  (state: IUsersState) => state.counters?.[UnreadCountersStates.replies],
);

export const selectLoginErrorCode = createSelector(selectFeature, (state) => {
  if (!state.error) {
    return null;
  }

  const body = state.error.error;
  return body?.error?.code ?? body?.code ?? null;
});

export const selectCurrentUserFavsShop = createSelector(
  selectFeature,
  (state: IUsersState) => state.currentUser?.favoriteShops,
);

export const selectUserPageData = createSelector(
  selectFeature,
  (state: IUsersState) => state.userPageData,
);

export const selectUsersDataIsLoading = createSelector(
  selectFeature,
  (state: IUsersState) => state.isLoading,
);

export const selectFavoriteFilesList = createSelector(
  selectFeature,
  (state: IUsersState) => state.favoriteFilesList,
);

export const selectUserAvatarIsLoading = createSelector(
  selectFeature,
  (state: IUsersState) => state.isAvatarLoading,
);
